import { addFieldEditor } from "aldoo-ra/CMS/field-editor-resolver"
import NewsletterTemplateSelectorEditor from "./field-editors/newsletter-template-selector"
import SendingRateInputEditor from "./field-editors/sending-rate-input"

// Register custom field editors
addFieldEditor("NewsletterTemplateSelector", NewsletterTemplateSelectorEditor)
addFieldEditor("SendingRateInput", SendingRateInputEditor)

/**
 * Newsletter Settings Content Type
 * Local-only content type for managing newsletter configuration via ParamIO
 */

// This content type is registered locally for UI purposes only
// Data is stored in ParamIO, not in the CMS database
const NewsletterSettingsContentType = {
  type: "NewsletterSettings",
  label: "",
  description: "Configuration settings for newsletter email templates and URLs",
  localOnly: true, // This indicates it's not stored in CMS database
  
  // Groups definition (separate from fields)
  groups: [
    {
      id: "sending",
      label: "Sending Configuration",
      description: "Configure email sending rates and retry settings for newsletter releases",
      expanded: true
    }
  ],

  // Fields as flat array with group assignments
  fields: [
    {
      id: "MAX_BATCH_SIZE",
      label: "Maximum Batch Size",
      description: "Maximum recipients per SparkPost transmission. SparkPost allows up to 10,000 per batch. Lower values provide more frequent progress updates but slower overall sending.",
      type: "Number",
      group: "sending",
      required: false,
      defaultValue: 5000,
      validation: {
        min: 100,
        max: 10000
      }
    },
    {
      id: "SPARKPOST_WEBHOOK_USERNAME",
      label: "SparkPost Webhook Username",
      description: "Basic auth username for SparkPost webhook authentication. Leave empty to disable authentication (development only).",
      type: "Text",
      group: "sending",
      required: false,
      defaultValue: ""
    },
    {
      id: "SPARKPOST_WEBHOOK_PASSWORD",
      label: "SparkPost Webhook Password",
      description: "Basic auth password for SparkPost webhook authentication. Leave empty to disable authentication (development only).",
      type: "Text",
      group: "sending",
      required: false,
      defaultValue: "",
      isPassword: true
    }
  ]
}

export default NewsletterSettingsContentType